<template>
  <div class="sznc-Login">
    <div class="minW login-head">
      <div class="change-btn">
        <el-button :type="loginType=='master'?'primary':''" @click="changeLoginType('master')">管理版</el-button>
        <el-button :type="loginType=='sub'?'primary':''" @click="changeLoginType('sub')">员工版</el-button>
      </div>
    </div>
    <div class="login-bg" :style="{backgroundImage:loginInfo.bgUrl ? `url(${commenUrl+loginInfo.bgUrl})` : '../../assets/images/user/login.jpg'}">
      
      <div class="minW login-main">
        <div class="login-main-font">
          <div class="plat-info-name">{{loginInfo.platName}}</div>
          <div class="plat-info-slogan">{{loginInfo.platSlogan}}</div>
          <div class="plat-info-detail">{{loginInfo.platDetails}}</div>
        </div>
        <div class="login-main-wrap">
          <div class="login-main-head">
            <div class="title">欢迎登录<span>{{headerTitle}}</span></div>
          </div>
          <div class="login-main-mid">
            <el-form :model="userPsdForm" ref="ruleFormRef" :rules="rules" v-if="loginType=='master'">
              <el-form-item label="" prop="username">
                <el-input v-model="userPsdForm.username" placeholder="请输入用户名称" clearable></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="userPsdForm.password" placeholder="请输入登录密码" type="password" clearable></el-input>
              </el-form-item>
              <div class="login-other-opts">
                <div><el-checkbox v-model="isRemember" size="small">记住密码</el-checkbox></div>
              </div>
              <el-form-item>
                <el-button type="primary" class="login-sub-btn"  @click="submitForm(ruleFormRef)">登录</el-button>
              </el-form-item>
            </el-form>
            <el-form :model="subUserPsdForm" ref="subruleFormRef" :rules="rules" v-else>
              <el-form-item label="" prop="username">
                <el-input v-model="subUserPsdForm.username" placeholder="请输入用户名称" clearable></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="subUserPsdForm.password" placeholder="请输入登录密码" type="password" clearable></el-input>
              </el-form-item>
              <div class="login-other-opts">
                <div><el-checkbox v-model="isRemember1" size="small">记住密码</el-checkbox></div>
              </div>
              <el-form-item>
                <el-button type="primary" class="login-sub-btn"  @click="submitForm(subruleFormRef)">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, reactive,ref } from "vue";
import { useRouter,useRoute } from "vue-router";
import Md5 from 'js-md5';
let Base64 = require('js-base64').Base64;
export default {
  name: "szncLogin",
  setup() {
    const {proxy} = getCurrentInstance();
    const router= useRouter();
    const route= useRoute();
    const headerTitle = ref(process.env.VUE_APP_PUBLIC_TITLE || "");
    let userPsdForm = reactive({});
    let subUserPsdForm=reactive({});
    let rules=reactive({
      username:[{ required: true, message: '请输入用户名', trigger: 'blur' },],
      password:[{ required: true, message: '请输入密码', trigger: 'blur' },],
    });

    let loginType=ref("master");
    let isRemember = ref();
    let isRemember1 = ref();
    let loginInfo=ref({
      platName:"产业工作台",
      platSlogan:"智联产业生态，赋能高效监管与可持续发展",
      platDetails:"依托产业运营服务优化资源配置。平台助力产地政府与龙头企业搭建高效监管与服务平台，推动产业健康发展，增强区域产业竞争力",
      bgUrl:""
    });
    function init() {
      if(localStorage.getItem("platLoginInfo")){
        let platLoginInfo=JSON.parse(localStorage.getItem("platLoginInfo"));
        platLoginInfo.map(item=>{
          if(item.platConfigType=='0'){
            loginInfo.value.platName=item.value
          }
          if(item.platConfigType=='1'){
            loginInfo.value.platSlogan=item.value
          }
          if(item.platConfigType=='2'){
            loginInfo.value.platDetails=item.value
          }
          if(item.platConfigType=='3'){
            loginInfo.value.bgUrl=item.value
          }
        });
      }
       userPsdForm.username = localStorage.getItem("szncUsername")
          ? localStorage.getItem("szncUsername")
          : "";
        userPsdForm.password = localStorage.getItem("szncPassword")
          ? localStorage.getItem("szncPassword")
          : "";
        if (userPsdForm.password) {
          isRemember.value = true;
        }
      subUserPsdForm.username = localStorage.getItem("subszncUsername")
          ? localStorage.getItem("subszncUsername")
          : "";
        subUserPsdForm.password = localStorage.getItem("subszncPassword")
          ? localStorage.getItem("subszncPassword")
          : "";
        if (subUserPsdForm.password) {
          isRemember1.value = true;
        }
    }
    init();
    let ruleFormRef=ref();
    let subruleFormRef=ref();
    function submitForm(formEl) {
      formEl.validate((valid, fields) => {
        if (valid) {
          console.log('submit!')
        } else {
          console.log('error submit!', fields)
          return false
        }
        var password ="",basic ="",loginUrl="MASTER_LOGIN";
        if(loginType.value=="master"){
          loginUrl="MASTER_LOGIN";
          password = Md5(userPsdForm.password);
          basic = "Basic " + Base64.encode(userPsdForm.username + ":" + password);
        }else{
          loginUrl="SUB_LOGIN";
          console.log(subUserPsdForm.password)
          password = Md5(subUserPsdForm.password);
          basic = "Basic " + Base64.encode(subUserPsdForm.username + ":" + password);
        }
        proxy
        .$request({
          url:loginUrl,
          method: "post", //可以不传method 默认是post请求，
          // 允许携带证书
          xhrFields: {withCredentials: true},
          headers: {'Authorization': basic,},
        })
        .then((res) => {
          if(res.data.code=='000'){
            proxy.setCookie("userInfoIndustry", JSON.stringify(res.data.result));
            if(route.query?.redirect){
              router.push(route.query.redirect);
            }else{
              router.push('/');
            }
            
            if(loginType.value=='master'){
              if (isRemember.value) {
                localStorage.setItem("szncUsername", userPsdForm.username);
                localStorage.setItem("szncPassword", userPsdForm.password);
              } else {
                localStorage.setItem("szncUsername", "");
                localStorage.setItem("szncPassword", "");
              }
            }else{
              if (isRemember1.value) {
                localStorage.setItem("subszncUsername", subUserPsdForm.username);
                localStorage.setItem("subszncPassword", subUserPsdForm.password);
              } else {
                localStorage.setItem("subszncUsername", "");
                localStorage.setItem("subszncPassword", "");
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        });
      })
    }
    function changeLoginType(val){
      loginType.value=val;
    }
    return {
      isRemember,
      isRemember1,
      init,
      loginType,
      changeLoginType,
      submitForm,
      ruleFormRef,
      subruleFormRef,
      rules,
      userPsdForm,
      subUserPsdForm,
      headerTitle,
      loginInfo
    };
  },
};
</script>
<style scoped lang="less">
.sznc-Login {
  width: 100vw;
  height: 100vh;
  background-color: #e2e9f3;
  overflow: hidden;
  .login-bg {
    width: 100vw;
    height: 100vh;
    background: url(../../assets/images/user/login.jpg) no-repeat center left;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .minW{
    width: 68vw;
    margin: 0 auto;
  }
  .login-head{
    position: relative;
    .change-btn {
      position: absolute;
      top: 10px;
      right: 0;
      .el-button {
        width: 5.83vw;
        height:2.5vw;
      }
    }
  }
  .login-main{
    height: 28vw;
    display: flex;
    justify-content: space-between;
    .login-main-font{
      width: 38.33vw;
      .plat-info-name{
        line-height:2.92vw;
        font-size: 2.4vw;
        color: #3E7FFF;
        font-family: "Alibaba_PuHuiTi_2.0_105_Heavy_105_Heavy";
        margin-bottom: 0.52vw;
      }
      .plat-info-slogan{
        line-height: 2.395vw;
        font-size: 1.875vw;
        color: #3E7FFF;
        font-family: "Alibaba_PuHuiTi_2.0_45_Light_45_Light";
        margin-bottom: 2.08vw;
      }
      .plat-info-detail{
        font-size: 1.04vw;
        line-height: 1.77vw;
        color: #021D53;
        font-family: "AlibabaPuHuiTi_2_55_Regular";
      }
    }
    .login-main-wrap {
      width: 25vw;
      height: 26.77vw;
      background: #fff;
      margin-top: 0.78vw;
      .login-main-head {
        padding: 2.91vw 3.39vw 3.02vw;
        .title {
          font-size: 1.67vw;
          line-height: 1.67vw;
          font-family: PingFangSC-Medium;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #2c2c2c;
          span{
            margin-left: 1.15vw;
            font-size: 1.25vw;
            color: #9d9cba;
          }
        }
      }
    }
  }
  :deep(.login-main-mid){
    padding: 0 3.39vw;
    .el-form-item{
      margin-bottom: 1.15vw;
    }
    .el-form-item__content{
      line-height:2.6vw;
      .el-input{
        line-height:2.6vw;
        .el-input__wrapper{
          background-color: #f6f6fa;
          border-radius: 2px;
          box-shadow: none;
          .el-input__inner{
            height:2.6vw;
            line-height:2.6vw;
            font-family: PingFangSC-Medium;
            font-size: 1vw;
            color: #2c2c2c;
          }
        }
      }
    }
    .login-sub-btn.el-button--primary {
      width: 100%;
      height:2.6vw;
      background-color: #3e7fff;
      border-radius: 2px;
      span{
        font-family: PingFangSC-Medium;
        font-size: 1vw;
        color: #ffffff;
      }
    }
  }
  .login-other-opts{
    line-height: 1vw;
    margin-bottom: 2.08vw;
    font-size: 1vw;
    color: #c7c7c7;
    a{
      color: #3e7fff;
    }
    .go-register{
      text-align: right;
    }
  }
  :deep(.el-checkbox.el-checkbox--small){
    height: 1vw;
  }
  :deep(.el-checkbox__label){
    color: #c7c7c7;
    font-size: 1vw;
  }
  :deep(.el-checkbox__inner){
    width: 1vw;
    height: 1vw;
  }
  :deep(.el-checkbox.el-checkbox--small .el-checkbox__inner::after){
    width: 0.3125vw;
    height: 0.52vw;
  }
  .el-button--primary {
    background: #3e7fff;
    //border-radius: 0.25vh;
    border-radius: 2px;
  }
}
</style>


